export function isAndroid() {
  return navigator.userAgent.match(/android/i) !== null;
}

export function isIphone() {
  return navigator.userAgent.match(/iphone/i) !== null;
}
